import './ui/theme.css'
// —— 顶部：按官方方式启用 GIF 解析（Pixi v7 对应 @pixi/gif v2.x）——
import '@pixi/gif'
import { Assets } from 'pixi.js'
Assets.setPreferences({ crossOrigin: 'anonymous' }) // 可留可去

import { createApp } from 'vue';
import App from './App.vue';
import axios from './axios';
import { getUserId } from './utils/userutil';
import { getUsername } from './utils/userService';
import { io } from 'socket.io-client';
import Router from "./router/index.js";
import { createPinia } from "pinia";
import { initGlobalTouchEffect } from './utils/globalTouchEffect'

const app = createApp(App);

// Pinia
const pinia = createPinia();
app.use(pinia);

// /battle-rooms
let roomSocket = null;
app.config.globalProperties.$connectRoomSocket = function () {
  if (!roomSocket || roomSocket.disconnected) {
    roomSocket = io("https://joygma.online/battle-rooms", {
      auth: { token: localStorage.getItem('token') || localStorage.getItem('authToken') || '' }
    });
    this.$roomSocket = roomSocket;
    app.config.globalProperties.$roomSocket = roomSocket;
  }
};
app.config.globalProperties.$disconnectRoomSocket = function () {
  if (roomSocket && roomSocket.connected) {
    roomSocket.disconnect();
    roomSocket = null;
    this.$roomSocket = null;
    app.config.globalProperties.$roomSocket = null;
  }
};

// /pve-battles
let pveSocket = null;
app.config.globalProperties.$connectPveSocket = function () {
  if (!pveSocket || pveSocket.disconnected) {
    pveSocket = io("https://joygma.online/pve-battles", {
      auth: { token: localStorage.getItem('authToken') }
    });
    this.$pveSocket = pveSocket;
    app.config.globalProperties.$pveSocket = pveSocket;
  }
};
app.config.globalProperties.$disconnectPveSocket = function () {
  if (pveSocket && pveSocket.connected) {
    pveSocket.disconnect();
    pveSocket = null;
    this.$pveSocket = null;
    app.config.globalProperties.$pveSocket = null;
  }
};

// 全局工具
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$getUserId = getUserId;
app.config.globalProperties.$getUsername = getUsername;

// 路由与挂载
app.use(Router);
app.mount('#app');

initGlobalTouchEffect()

const isInstalledApp = () =>
  window.matchMedia?.('(display-mode: fullscreen)')?.matches ||
  window.matchMedia?.('(display-mode: standalone)')?.matches ||
  window.navigator.standalone === true

const requestFullscreenAfterGesture = () => {
  if (isInstalledApp() || document.fullscreenElement || !document.fullscreenEnabled) return

  const target = document.documentElement
  if (!target.requestFullscreen) return

  target.requestFullscreen({ navigationUI: 'hide' }).catch(() => {})
}

const enableGameFullscreenGesture = () => {
  const events = ['pointerdown', 'touchstart', 'keydown']
  const cleanup = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, handleGesture, true)
    })
  }
  const handleGesture = () => {
    requestFullscreenAfterGesture()
    cleanup()
  }

  events.forEach((eventName) => {
    window.addEventListener(eventName, handleGesture, { capture: true, once: true, passive: true })
  })
}

enableGameFullscreenGesture()

if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {})
  })
}
